import API from "../../utils/api";
import {
    FETCHED_DOCUMENTS_FILTERS,
    FETCHED_DOCUMENTS_NAMES,
    SET_DOCUMENTS_FILTERS_LOADING,
    SET_DOCUMENTS_NAMES_LOADING
} from "../constants";
import {Action} from "./app";
import {localStorageAccessTokenKey} from "../../utils/constants";

export const setDocumentsNamesLoading = (value: boolean): Action => ({
    type: SET_DOCUMENTS_NAMES_LOADING,
    payload: value
});

export const getDocumentsNames = (payload: any) => async(dispatch: any) => {
    const token = localStorage.getItem(localStorageAccessTokenKey);
    try {
        const response = await API.get("titles?type=laws", {
            params: payload,
            headers: {"Authorization": "Bearer " + token}
        });
        dispatch({ type: FETCHED_DOCUMENTS_NAMES, payload: response.data });
        return response;
    } catch (err) {
        return err;
    }
};
